import { Grid } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const TextColumnContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[800]};

  ${({ theme }) => theme.breakpoint.minWidth('md')} {
    &:not(:has(> div:only-of-type)) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      align-items: flex-start;
    }

    &:has(> div:nth-of-type(3)) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;
export const Column = styled(Grid) `
  flex-grow: 1;

  &:not(:only-of-type) {
    img {
      min-height: initial;
    }
  }

  &:only-of-type {
    grid-template-columns: repeat(1, minmax(0, 1fr));

    & > div:first-of-type {
      grid-row: 2;
    }

    & > div:nth-of-type(2) {
      grid-row: 1;
    }

    ${({ theme }) => theme.breakpoint.minWidth('md')} {
      & > div:first-of-type {
        grid-row: 2;
        grid-column: 2;
      }

      & > div:nth-of-type(2) {
        grid-row: 1;
        grid-column: 1;
      }

      & > div:last-of-type {
        grid-row: 2;
        grid-column: 1;
      }
    }
  }
`;
//# sourceMappingURL=TextColumn.styled.js.map